import script from "./WorksView.vue?vue&type=script&setup=true&lang=js"
export * from "./WorksView.vue?vue&type=script&setup=true&lang=js"

import "./WorksView.vue?vue&type=style&index=0&id=7ad17a34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ad17a34"]])

export default __exports__